//@ts-check
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import JobToolbar from './JobToolbar';
import dompurify from 'dompurify';
var sanitizer = dompurify.sanitize;
/**
 * @param {import('./types').JobFinishedProps} params
 */

var JobFinished = function JobFinished(_ref) {
  var job = _ref.job,
      project = _ref.project,
      toolbar = _ref.toolbar,
      message = _ref.message;
  var runMessage = sanitizer(project.RunMessage);

  var _ref2 = toolbar || {},
      title = _ref2.title,
      onClose = _ref2.onClose;

  return React.createElement(React.Fragment, null, toolbar && React.createElement(JobToolbar, {
    job: job,
    title: title,
    onClose: onClose
  }), React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, null, React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: sanitizer(message) || runMessage
    }
  })))));
};

export default JobFinished;